import { UserAvatar } from '../UserAvatar';
import { memberDisplayName, type MemberDto } from '../../lib/work-types';
import { cn } from '../../lib/utils';

export function MemberByline({
  members,
  userId,
  size = 20,
  className,
  nameClassName,
}: {
  members: Map<string, MemberDto>;
  userId: string | null;
  size?: number;
  className?: string;
  nameClassName?: string;
}) {
  if (!userId) return null;
  const member = members.get(userId) ?? null;
  // Members load after the page; an id that never resolves belongs to someone who has left.
  const name = member ? memberDisplayName(member) : members.size > 0 ? 'Former member' : '…';
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <UserAvatar name={name} src={member?.avatar_url} size={size} />
      <span className={cn('truncate', nameClassName)}>{name}</span>
    </span>
  );
}
